import { createAction, props } from '@ngrx/store';

import {
  IListMessagesByRoomInput,
  IListMessagesByRoomResult,
} from '@shared/models/messages';

export const resetMessagesAction = createAction('[Messages] Reset');

export const listMessagesByRoomAction = createAction(
  '[Messages] List Messages By Room',
  props<IListMessagesByRoomInput>()
);

export const listMessagesByRoomActionSuccess = createAction(
  '[Messages] List Messages By Room Success',
  props<IListMessagesByRoomResult>()
);

export const listMessagesByRoomActionFailure = createAction(
  '[Messages] List Messages By Room Failure'
);
